import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Arizona = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Arizona Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. No specific disclosure form; checklist format provided by state
          Realtor associations.
        </Text>

        <Text style={styles.listItem}>
          2. SPDS Form: Sellers Property Disclosure Statement (SPDS) is
          required.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Comprehensive Loss Underwriting Exchange (C.L.U.E.)
          </Text>{' '}
          – The seller must provide the buyer with a list of any claims made on
          the property. This can be completed online via LexisNexis, or rights
          can be waived through a waiver form.
        </Text>

        <Text style={styles.listItem}>
          5. <Text style={styles.underline}>Condominium Disclosure</Text> –
          Applicable to properties sold within a homeowner's association or
          condominium/planned community.
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Property Disclosure Statement</Text>{' '}
          – The seller must disclose known information about the property's
          condition and any known problems.
        </Text>

        <Text style={styles.listItem}>
          7. <Text style={styles.underline}>Soil Remediation Disclosure</Text> –
          The buyer must be notified if the property has undergone soil
          remediation. This can be mentioned in the Property Disclosure
          Statement.
        </Text>

        <Text style={styles.listItem}>
          8. <Text style={styles.underline}>Swimming Pool Disclosure</Text> –
          The seller must provide this Department of Health Services notice to
          the buyer when selling a property with a pool.
        </Text>

        <Text style={styles.listItem}>
          9.{' '}
          <Text style={styles.underline}>Unincorporated Area Disclosure</Text> –
          A special disclosure for sellers of property (five or fewer parcels)
          on unincorporated land.
        </Text>
      </View>
    </View>
  );
};

export default Arizona;
